import axios from 'axios';

// Whether app is in maintenance mode
export const isMaintenanceMode = async () => {
  try {
    await axios.get(`${process.env.VUE_APP_MAINTENANCE_URL}`);
    return true;
  } catch (error) {
    if (window.location.hostname !== 'localhost') {
      console.clear();
    }
    return false;
  }
};
